<template>
	<div class="ppg-generation-result">
		<a
			v-if="isFile"
			href="#"
			class="ppg-generation-result__link"
			@click.prevent="openGeneratedWork"
		>
			{{ $t("openGeneratedWork") }}
		</a>

		<vs-alert v-else-if="isError" color="danger">
			{{ result.value }}
		</vs-alert>

		<span v-else class="ppg-generation-result__empty">—</span>
	</div>
</template>

<script>
import notifier from "@/mixins/notifier";

export default {
	name: "PpgGenerationResult",
	mixins: [notifier],
	props: {
		result: { default: null, type: Object }
	},
	computed: {
		userRole() {
			return this.$store.state.auth.role;
		},

		isFile() {
			return !!this.result && this.result.type === "file" && !!this.result.s3_id;
		},

		isError() {
			return !!this.result && this.result.type === "error" && !!this.result.value;
		}
	},
	methods: {
		async openGeneratedWork() {
			try {
				const response = await this.$http.post(
					`/${this.userRole}/order/download-url`,
					{ s3_id: this.result.s3_id }
				);

				const downloadUrl = response.data.data.downloadUrl;

				if (!downloadUrl) {
					this.notifyError(this.$t("fileDownloadError"));
					return;
				}

				window.open(downloadUrl, "_blank");
			} catch (e) {
				this.notifyError(this.$t("fileDownloadError"));
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.ppg-generation-result {
	&__link {
		word-break: break-all;
	}

	&__empty {
		color: gray;
	}
}
</style>
